import {DateSlot, Location, TimeSlot} from 'components/TimePicker/types';

export const filterLocation = (loc: Location): DateSlot[] => {
	if (!loc.details.isPrivate) {
		return filterDates(loc.datesBase);
	}
	return [];
};

const filterDates = (slots: DateSlot[]): DateSlot[] => {
	// 1. Remove private dates
	// 2. Remove reserved time slots
	// 3. Remove dates without slots left
	// 4. Re-index remaining dates
	return slots
		.filter((s) => !s.isPrivate)
		.map((s) => ({
			...s,
			timesLeft: filterTimes(s.timesBase),
		}))
		.filter((s) => s.timesLeft.length > 0)
		.map((s, index) => ({
			...s,
			index,
		}));
};

export const filterTimes = (slots: TimeSlot[]): TimeSlot[] => {
	// 1. Remove reserved time slots
	// 2. Re-index remaining times
	return slots
		.filter((s) => s.canReserve)
		.map((s, index) => ({
			...s,
			index,
		}));
};
